import React, { useState } from 'react';
import './login.css';
import { supabase } from '../supabase';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const { error } = await supabase.auth.signInWithPassword({
      email,
      password
    });

    setLoading(false);

    if (error) {
      setError(error.message);
      return;
    }

    navigate('/overview');
  };

  return (
    <div className="loginpage">

      <div className="loginglow"></div>

      <div className="logincontainer">

        <div className="loginleft">
          <h1>Fashion Week Admin</h1>
          <p>Manage tickets, schedule, reviews & analytics in one place.</p>

          <div className="loginbadge">
            Secure Dashboard Access
          </div>
        </div>

        <div className="logincard">

          <h2>Welcome Back</h2>
          <p className="subtext">Please sign in to continue</p>

          <form className='logform' onSubmit={handleLogin}>

            <input
              type="email"
              placeholder="Email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            {error && <div className="error">{error}</div>}

            <button disabled={loading}>
              {loading ? 'Signing in...' : 'Login'}
            </button>

          </form>
    <p className='helppp'>Email:janna@gmail.com
        <br />
        password:123456
    </p>
          <p className="helppp">
            © 2026 Fashion Week Admin Panel
          </p>

        </div>

      </div>
    </div>
  );
};

export default Login;